import { useMemo, useState } from "react";
import useGallery, { useFiltered } from "@/hooks/useGallery";
import FilterBar from "@/components/FilterBar";
import GalleryGrid from "@/components/GalleryGrid";
import Lightbox from "@/components/Lightbox";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/Seo";

const FILTERS = ["All", "Photography", "Video"];

export default function ShotTypePage({ shotType, eyebrow, title, intro, seoTitle, seoDescription, path, testid }) {
  const { items, loading } = useGallery();
  const scoped = useMemo(
    () => items.filter((i) => (shotType === "aerial" ? i.shot_type === "aerial" : i.shot_type !== "aerial")),
    [items, shotType]
  );
  const [filter, setFilter] = useState("All");
  const [activeId, setActiveId] = useState(null);
  const filtered = useFiltered(scoped, filter);

  return (
    <div className="px-5 sm:px-8 lg:px-10 pt-10 lg:pt-12 pb-16">
      <Seo title={seoTitle} description={seoDescription} path={path} />
      <PageHeader eyebrow={eyebrow} title={title} intro={intro} testid={testid} />
      <div className="mt-10 mb-8 overflow-x-auto -mx-2 px-2">
        <FilterBar active={filter} onChange={setFilter} categories={FILTERS} />
      </div>
      {loading ? (
        <div className="text-[#737373] text-xs tracking-[0.24em] uppercase py-20 text-center">
          Loading…
        </div>
      ) : (
        <GalleryGrid items={filtered} onOpen={setActiveId} />
      )}
      {activeId !== null && (
        <Lightbox
          items={filtered}
          activeId={activeId}
          onClose={() => setActiveId(null)}
          onChange={setActiveId}
        />
      )}
    </div>
  );
}
